<template>
  <path
    fill-rule="evenodd"
    d="M74.866 1.444C66.123 1.227 25.09-4.128 12.223 9.37-.606 22.826-3.745 50.184 7.925 60.667 19.595 71.15 57.92 68.7 68.213 68.955c6.72.167 43.363-1.366 56.433-11.219 9.18-6.92 11.849-21.03 4.524-36.42C121.752 2.395 80.784 1.59 74.866 1.443z"
  />
</template>

<script>
export default {}
</script>



// WEBPACK FOOTER //
// components/_SVG/ShapeYearBtn1Mob.vue